import type { RootState } from 'store';

export const selectCurrentUser = (state: RootState): IUser | null | undefined => {
  return state.auth.user;
};

export const getUserSelector = (state: RootState): IUser | null | undefined => {
  return state.auth.user;
};

export const getClientIdSelector = (state: RootState): string | null | undefined => {
  return state.auth.user?.client;
};

export const getTokenSelector = (state: RootState): IToken | null | undefined => {
  return state.auth.token;
};

export const getUserFullName = (state: RootState) => {
  const { user } = state.auth;
  if (user) {
    return `${user.firstName} ${user.lastName}`;
  }
  return '-';
};

export const getUserRole = (state: RootState) => {
  const { user } = state.auth;
  if (user) {
    return user.role;
  }
  return '-';
};

export const getUserClientId = (state: RootState) => {
  const { user } = state.auth;
  if (user) {
    return user.client;
  }
  return '-';
};
